import { useMemo } from "react";
import pickBy from "lodash/pickBy";
import isArray from "lodash/isArray";
import isNumber from "lodash/isNumber";
import {
  getAggregationHandler,
  getLutParameters,
  getRestParameterValues,
  transformSearchFiltersToQuery,
  replaceParametersInQueryString,
  getStreams
} from "views/logic/valueactions/createEventDefinition/hooks/hookHelpers";
const useMappedData = ({ contexts, field, queryId, value }) => useMemo(() => {
  const aggregationHandler = getAggregationHandler({ widget: contexts.widget, field });
  const curQuery = contexts.view.search.queries.find((query) => query.id === queryId);
  const { parameters, parameterBindings } = contexts;
  const searchWithinMs = curQuery.timerange.type === "relative" ? curQuery.timerange.from * 1e3 : void 0;
  const lutParameters = getLutParameters(parameters);
  const restParameterValues = getRestParameterValues({
    parameters,
    parameterBindings
  });
  const searchFilterQuery = transformSearchFiltersToQuery(curQuery.filters);
  const queryWithReplacedParams = replaceParametersInQueryString({
    query: curQuery.query.query_string,
    restParameterValues
  });
  const streams = getStreams(curQuery.filter);
  const { ...aggregationVales } = aggregationHandler({
    valuePath: contexts.valuePath,
    widget: contexts.widget,
    value,
    field
  });
  const data = {
    searchWithinMs,
    lutParameters,
    searchFilterQuery,
    queryWithReplacedParams,
    streams,
    ...aggregationVales
  };
  return pickBy(data, (v) => {
    if (isArray(v)) {
      return !!v.length;
    }
    if (isNumber(v)) {
      return true;
    }
    return !!(v == null ? void 0 : v.trim());
  });
}, [contexts, field, queryId, value]);
export default useMappedData;
